export type QuotesQuoteInitialStatus = 'TO_BE_SENT' | 'AWAITING_APPROVAL';

export const QuotesQuoteInitialStatus = {
  TOBESENT: 'TO_BE_SENT' as QuotesQuoteInitialStatus,
  AWAITINGAPPROVAL: 'AWAITING_APPROVAL' as QuotesQuoteInitialStatus,
};
